import { di } from 'react-magnetic-di';

import { isStudioV2 } from '../get-studio-version';
import { getWorkspacePath, SPACE_PREFIX, WORKSPACE_PREFIX } from '../workspace';

/**
 * Given a path, return the path with the workspace and space prefix prepended if we are in v2.
 * This is only intended to be used in v1.
 * e.g. /agents -> /w/:workspaceId/spaces/:spaceId/agents
 * @param path - The path to prepend the workspace prefix to.
 * @returns The path with the workspace prefix prepended if we are in v2.
 */
export const getStudioPath = (path: string): string => {
	di(isStudioV2);

	if (!path.startsWith(`${WORKSPACE_PREFIX}${SPACE_PREFIX}`) && isStudioV2()) {
		return getWorkspacePath(path, { appendSpacePrefix: true });
	}

	return path;
};
